// extracted by mini-css-extract-plugin
export default {"bold":"sytles_bold__Ad5sk","filterBtn":"sytles_filterBtn__xf--p"};